import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { FaGraduationCap, FaBriefcase, FaTrophy } from 'react-icons/fa';

const ExperiencePage = () => {
    const education = [
        {
            institution: "Vellore Institute of Technology",
            degree: "B.Tech in Computer Science & Engineering",
            specialization: "Specialization in AI & ML",
            grade: "9.25 CGPA",
            duration: "2023 - 2027"
        },
        {
            institution: "High School",
            isHighSchool: true,
            hssc: { name: "HSSC (12th)", grade: "93%", year: "2023" },
            ssc: { name: "SSC (10th)", grade: "96.4%", year: "2021" }
        }
    ];

    const experience = [
        {
            company: "Debales AI",
            role: "AI Developer Intern",
            location: "Remote",
            duration: "Dec 2025 - Present",
            points: [
                "Developing FastAPI endpoints to expose client-specific AI agent workflows powered by LangGraph-based agent pipelines.",
                "Working with MongoDB-backed prompt management, enabling dynamic prompt loading, versioning, and per-client customization without redeployments.",
                "Supporting a multi-tenant production AI system, integrating agent routing, tool selection, and backend services with proper error handling and observability.",
                "Creating multiple marketing-based deep research n8n automation agents that help generate relevant marketing strategies, multiple blogs, and automate posting."
            ]
        },
        {
            company: "VIT Android Club",
            role: "Technical Team Member, R&D Department",
            duration: "2024 - Present",
            points: [
                "Maintained club's projects and repositories during ACWOC (Android Club Winter of Code) open source contribution event.",
                "Judged multiple ML-related hackathon projects during club events, evaluating technical implementations and innovation.",
                "Conducted research on ML/AI and Android integration, exploring ways to bring machine learning capabilities to mobile applications."
            ]
        }
    ];

    const achievements = [
        {
            title: "1st Place - AI Demos × AI For Content Creators Hackathon",
            description: "Winner and Jury's Pick for Creator Catalyst - an AI content repurposing platform",
            icon: <FaTrophy />,
            link: "https://www.linkedin.com/posts/pradipnichite_ai-demos-community-activity-7381660078497497088-Xuhm"
        }
    ];

    return (
        <div className="page-container experience-page">
            <Fade triggerOnce duration={800}>
                <h1 className="page-title">Experience & Education</h1>
            </Fade>

            {/* Work Experience Section - First */}
            <Fade triggerOnce duration={600} delay={100}>
                <section className="work-section">
                    <h2 className="section-heading">
                        <FaBriefcase className="heading-icon" />
                        Work Experience
                    </h2>
                    <div className="experience-cards">
                        {experience.map((exp, index) => (
                            <div key={index} className="experience-card">
                                <div className="exp-header">
                                    <div>
                                        <h3 className="exp-role">{exp.role}</h3>
                                        <p className="exp-company">{exp.company}</p>
                                        {exp.location && <p className="exp-location">{exp.location}</p>}
                                    </div>
                                    <span className="exp-duration">{exp.duration}</span>
                                </div>
                                <ul className="exp-points">
                                    {exp.points.map((point, pIndex) => (
                                        <li key={pIndex}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </section>
            </Fade>

            {/* Education Section - Second */}
            <Fade triggerOnce duration={600} delay={200}>
                <section className="education-section">
                    <h2 className="section-heading">
                        <FaGraduationCap className="heading-icon" />
                        Education
                    </h2>
                    <div className="education-cards">
                        {education.map((edu, index) => (
                            <div key={index} className="education-card">
                                {edu.isHighSchool ? (
                                    <>
                                        <h3 className="edu-institution">{edu.institution}</h3>
                                        <div className="highschool-grades">
                                            <div className="hs-row">
                                                <span className="hs-name">{edu.hssc.name}</span>
                                                <span className="hs-grade highlight">{edu.hssc.grade}</span>
                                                <span className="hs-year">{edu.hssc.year}</span>
                                            </div>
                                            <div className="hs-row">
                                                <span className="hs-name">{edu.ssc.name}</span>
                                                <span className="hs-grade highlight">{edu.ssc.grade}</span>
                                                <span className="hs-year">{edu.ssc.year}</span>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="edu-header">
                                            <h3 className="edu-institution">{edu.institution}</h3>
                                            <span className="edu-duration">{edu.duration}</span>
                                        </div>
                                        <p className="edu-degree">{edu.degree}</p>
                                        {edu.specialization && <p className="edu-spec">{edu.specialization}</p>}
                                        <p className="edu-grade"><span className="highlight">{edu.grade}</span></p>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </section>
            </Fade>

            {/* Achievements Section - Third */}
            <Fade triggerOnce duration={600} delay={400}>
                <section className="achievements-section">
                    <h2 className="section-heading">
                        <FaTrophy className="heading-icon" />
                        Achievements
                    </h2>
                    <div className="achievements-cards">
                        {achievements.map((achievement, index) => (
                            <a
                                key={index}
                                href={achievement.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="achievement-card"
                            >
                                <span className="achievement-icon">{achievement.icon}</span>
                                <div className="achievement-info">
                                    <h3 className="achievement-title">{achievement.title}</h3>
                                    <p className="achievement-desc">{achievement.description}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </section>
            </Fade>
        </div>
    );
};

export default ExperiencePage;
